import React, { useEffect, useState } from 'react';
import DataTable from '../../components/DataTablePtBr';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/Header';
import api from '../../services/api';
import { showError, showConfirmation, showSuccess } from '../../services/alert';

const CategoriaFinanceiraList = () => {
  const [categorias, setCategorias] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Busca todas as categorias financeiras
  const fetchCategorias = async () => {
    setLoading(true);
    try {
      const res = await api.get('/categoriafinanceira');
      setCategorias(res.data);
    } catch (err) {
      console.error('Erro ao buscar categorias financeiras:', err);
      showError('Erro ao buscar categorias financeiras.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategorias();
  }, []);

  // Exclui uma categoria
  const handleDelete = async (id) => {
    const confirmou = await showConfirmation({
      title: 'Excluir categoria financeira?',
      text: 'Tem certeza que deseja remover esta categoria?',
      confirmText: 'Sim, excluir',
      cancelText: 'Cancelar',
    });

    if (!confirmou) return;

    try {
      await api.delete(`/categoriafinanceira/${id}`);
      showSuccess('Categoria removida com sucesso.');
      fetchCategorias();
    } catch (err) {
      console.error('Erro ao excluir categoria financeira:', err);
      showError(err.response?.data?.message || 'Erro ao excluir categoria.');
    }
  };

  // Define colunas da tabela
  const columns = [
    {
      name: 'Nome',
      selector: row => row.nome,
      sortable: true,
    },
    {
      name: 'Tipo',
      selector: row => row.tipo,
      sortable: true,
    },
    {
      name: 'Ações',
      cell: row => (
        <div className="d-flex gap-1">
          <button
            className="btn btn-outline-success btn-sm d-flex align-items-center gap-1"
            onClick={() => navigate(`/categoriafinanceira/editar/${row.id}`)}
          >
            <i className="bi bi-pencil-square"></i>
            <span>Editar</span>
          </button>
          <button
            className="btn btn-outline-danger btn-sm d-flex align-items-center gap-1"
            onClick={() => handleDelete(row.id)}
          >
            <i className="bi bi-trash"></i>
            <span>Excluir</span>
          </button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      minWidth: '160px',
      style: { whiteSpace: 'nowrap' },
    },
  ];

  return (
    <div className="container mt-4">
      <Header />
      <div className="card shadow-lg border-0 rounded-3">
        <div className="card-header bg-success text-white d-flex justify-content-between align-items-center rounded-top-3">
          <div className="d-flex align-items-center gap-3">
            <button
              className="btn btn-light btn-sm d-flex align-items-center gap-1"
              onClick={() => navigate('/menu')}
            >
              <i className="bi bi-arrow-left text-success"></i>
              <span className="text-success fw-semibold">Voltar</span>
            </button>
            <div>
              <h5 className="mb-0">Categorias Financeiras</h5>
              <small className="text-white-50">Gerencie receitas e despesas</small>
            </div>
          </div>
          <button
            className="btn btn-light text-success fw-bold d-flex align-items-center gap-1"
            onClick={() => navigate('/categoriafinanceira/create')}
          >
            <i className="bi bi-plus-circle"></i>
            <span>Nova Categoria</span>
          </button>
        </div>
        <div className="card-body">
          <DataTable
            columns={columns}
            data={categorias}
            pagination
            responsive
            highlightOnHover
            striped
            progressPending={loading}
            noDataComponent={<div className="text-muted">Nenhuma categoria encontrada.</div>}
          />
        </div>
      </div>
    </div>
  );
};

export default CategoriaFinanceiraList;
